import React from "react";
import { Link } from 'react-router-dom';
import { PrettyDate } from "../../helpers/DateHelper";


export default class MarketData extends React.Component {
    constructor(props) {
        super(props);
        this.state =
        {
            isLoading: true,
            isError: false,
            marketData: []
        };
    }

    async setupMarketData() {
        try {
            var url = 'api/MarketData/GetMarketData';
            const response = await fetch(url);
            const data = await response.json();
            this.setState({ marketData: data, isLoading: false });
        }
        catch {
            this.setState({ isError: true });
        }
    }

    async componentDidMount() {
        await this.setupMarketData();
    }

    static getMaxTimeUsingLastPrice(objectList) {
        const maxObject = objectList.reduce((max, obj) => {
            if (obj !== null && max === null) {
                return obj;
            }
            else if (max !== null && obj !== null) {
                const currentDateTime = new Date(obj.refLastPrice).getTime();
                const maxDateTime = max ? new Date(max.refLastPrice).getTime() : 0;
                return currentDateTime > maxDateTime ? obj : max;
            }
            return "";
        }, null);
        if (maxObject === null || maxObject === "") {
            return "";
        }
        if (maxObject.refLastPrice === null || maxObject.refLastPrice === "") {
            return "";
        }
        return PrettyDate(maxObject.refLastPrice, 'dd MMM yyyy hh:mm:ss');
    }
    static getMaxTimeUsingBBOPrice(objectList) {
        const maxObject = objectList.reduce((max, obj) => {
            if (obj !== null && max === null) {
                return obj;
            }
            else if (obj !== null && max !== null) {
                const currentDateTime = new Date(obj.refBBOPrice).getTime();
                const maxDateTime = max ? new Date(max.refBBOPrice).getTime() : 0;
                return currentDateTime > maxDateTime ? obj : max;
            }
            return "";
        }, null);
        if (maxObject === null || maxObject === "") {
            return "";
        }
        if (maxObject.refBBOPrice === null || maxObject.refBBOPrice === "") {
            return "";
        }
        return PrettyDate(maxObject.refBBOPrice, 'dd MMM yyyy hh:mm:ss');
    }
    static renderMarketDataTable(stockList) {
        function getSignColor(oldValue, newValue) {
            if (oldValue > newValue) {
                return "red";
            }
            else if (newValue > oldValue) {
                return "green";
            }
            else {
                return "black";
            }
        }

        let maxBBODateTime = MarketData.getMaxTimeUsingBBOPrice(stockList);
        let maxLastDateTime = MarketData.getMaxTimeUsingLastPrice(stockList);
        return <>
            <div id="market-data" className='round-box'>
                <table className="pretty-table">
                    <thead>
                        <tr>
                            <th>ชื่อหุ้น</th>
                            <th>ราคาล่าสุด</th>
                            <th>เปลี่ยนแปลง</th>
                            <th>Fair Bid</th>
                            <th>Fair Ask</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stockList.map((i, index) => <tr key={`market-data-${index}`}>
                            <td className="bold">
                                <Link to={`/DRDetail/${i.symbol}`}>
                                    <img className="icon-24" src={`${i.iconUrl}`} alt="" />
                                    {` `}
                                    {i.symbol}
                                </Link>
                            </td>
                            <td className="bold">{i.displayLastPrice}</td>
                            <td className={getSignColor(i.priorPrice, i.lastPrice)}>{i.displayPercentChange} %</td>
                            <td>{i.displayBestBidPrice}</td>
                            <td>{i.displayBestOfferPrice}</td>
                        </tr>)}
                    </tbody>
                </table>

            </div>
            <div className="small-remarks">
                - {(maxLastDateTime !== "" ? `ราคาล่าสุด ${maxLastDateTime}` : "")} | {(maxBBODateTime !== "" ? `Bid - Ask ล่าสุด ${maxBBODateTime}` : "")}
                <br></br>
                - ราคา Fair Bid-Ask ราคาเหมาะสมของหุ้น DR โดยคำนวนจากราคาหุ้นอ้างอิงปัจจุบัน อัตราแลกเปลี่ยนและอัตราส่วนหุ้น DR (ราคาอาจจะไม่ตรงกับราคาในตลาด)
            </div>
        </>
    }



    render() {
        if (this.state.isError) {
            return <p><em>Sorry, something went wrong. Please try again later</em></p>;
        } else {
            if (this.state.isLoading) {
                return <p><em>Loading...</em></p>;
            } else {
                // the data is ready at this point
                return MarketData.renderMarketDataTable(this.state.marketData);
            }
        }
    }
}